import axios from "axios";
import React, { useEffect, useState } from "react";
import "./pendataanAset.css";
import TableNew from "./table/tableNew";
import BarChart from "./chart/barChart";
import { Link } from "react-router-dom";
import { DataAPi } from "./variable/dataVariable";

function Inventaris() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const getAset = async() => {
            setLoading(true);
            await axios.get((DataAPi.urlGetAll))
            .then(res => {
                setData(res.data)
                setLoading(false)
            })
            .catch(err => console.log(err));
        }
        getAset();
    },[]);

    const sortDataUp = data.sort((a, b) => a.tahunAnggaran - b.tahunAnggaran);

    let dataSet = [...new Set(sortDataUp.map((data) => data.tahunAnggaran))]

    let dataLabel = sortDataUp.map((data) => {
        let dataSet = {
            x: data.tahunAnggaran,
            y: data.hargaSatuan
        }
        return dataSet
    })

    let resultData = dataLabel.reduce((acc, {x, y}) => {
        if (!acc[x]) {
            acc[x] = {x, y, count: 1};
        } else {
            acc[x].y += y;
            acc[x].count++;
        }
        return acc;
    }, {})

    const userData = {
        labels: dataSet,
        datasets: [{
            label: "Total Belanja Aset",
            data: Object.values(resultData),
            backgroundColor: "#50ccab",
            borderColor: "black",
            borderWidth: 2,
            borderRadius: 5,
            borderSkipped: false,
        }],
    }

    const userOption = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'SINERGI UNISKI : Grafik Belanja Aset',
            },
        },
    }
    return (
        <div className="container-fluid"> 
            {loading ? (
                <div className="loader-container">
                    <div className="spinner"></div>
                </div>
            ):(
            <div className="container">
                <div className="row g-3 border p-2 pb-5" id="FormFilter">
                    <div className="col-md-12 row g-0">

                        <div className="col-md-8 p-2 mt-4 mb-4 text-center border border-2 rounded ">
                            <BarChart chartData={userData} chartOption={userOption} />
                        </div>

                        <div className="col-md-4 p-5 text-center">
                            <Link to="/input-aset">
                                <button type="button" class="btn btn-success btn-lg my-2" style={{width: "100%"}}>
                                    Tambah Aset <i class="bi bi-plus-lg text-light"></i>
                                </button>
                            </Link>
                
                            <Link to="/inventaris/rekapitulasi"><button className="btn btn-outline-primary btn-lg my-2" style={{width: "100%"}}>Daftar Inventaris</button></Link>
                            <Link to="/inventaris/print/data/aset"><button className="btn btn-outline-primary btn-lg my-2" style={{width: "100%"}}>Cetak Daftar Inventaris</button></Link>
                            <Link to="/inventaris/print/data/qrcode"><button className="btn btn-outline-primary btn-lg my-2" style={{width: "100%"}}>Nomor Inventarsi Barang</button></Link>
                        </div>

                        <div className="col-md-12 row g-0 p-2 bg-input">
                            <div className="col-md-12 d-grid p-2">
                                <h6 className="text-secondary-emphasis m-0">Baru ditambahkan kedalam Sistem Inventaris Aset Digital Universitas Islam Ogan Komering Ilir Kayuagung.</h6>
                            </div>
                        </div>

                        <div className="overflow-auto">
                            <TableNew dataSet={data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))} />
                        </div>
                    </div>
                </div>
            </div>
            )}
        
        </div>
    );
}
export default Inventaris;